import { render } from "./CardProfile.vue?vue&type=template&id=0f07b6b2&scoped=true&ts=true"
import script from "./CardProfile.vue?vue&type=script&lang=ts"
export * from "./CardProfile.vue?vue&type=script&lang=ts"

import "./CardProfile.vue?vue&type=style&index=0&id=0f07b6b2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f07b6b2"]])

export default __exports__